import axios from 'axios';
import config from "../config";
import BaseInterceptors from "../interceptors/BaseInterceptors";

/**
 * Library for making non-secure HTTP Requests
 */
export default class HttpLibrary {

    /**
     * HttpLibrary constructor
     *
     * @param {string} baseURL
     * @param {object} headers
     */
    constructor (baseURL = config.http.GATEWAY_API_URL, headers = config.http.GATEWAY_API_HEADERS) {
        this._instance = axios.create({
            baseURL,
            headers,
            timeout: 30000
        });
        BaseInterceptors.addBaseInterceptors(this._instance);
    }

    /**
     * Sends a GET request
     *
     * @param {string} url
     * @param {object} params
     * @returns {AxiosPromise<any>}
     */
    get (url, params = {}) {
        return this._instance.get(url, { params: { ...params } });
    }

    /**
     * Sens a PUT request
     *
     * @param {string} url
     * @param {object} params
     * @returns {AxiosPromise<any>}
     */
    put (url, params = {}) {
        return this._instance.put(url, { params: { ...params } });
    }

    /**
     * Sends a POST request
     * @param {string} url
     * @param {object} data
     * @param {object} params
     * @returns {AxiosPromise | *}
     */
    post (url, data, params = {}) {
        return this._instance.post(url, data, params);
    }

    /**
     * Sends a DELETE request
     *
     * @param {string} url
     * @param {object} params
     * @returns {AxiosPromise | *}
     */
    delete (url, params = {}) {
        return this._instance.delete(url, params);
    }
}



// WEBPACK FOOTER //
// ./src/libraries/HttpLibrary.js